import { useState } from 'react'

import { useInterval } from '@chakra-ui/react'

const DEFAULT_TICK_INTERVAL = 1000

export const useCurrentTimeTick = (tickInterval = DEFAULT_TICK_INTERVAL) => {
    const [currentTime, setCurrentTime] = useState(() => new Date())

    useInterval(() => {
        setCurrentTime(new Date())
    }, tickInterval)

    return currentTime
}
